/// <reference path="enums.js" />

import React, { Component } from 'react'
//import PropTypes from 'prop-types'
import { Route } from 'react-router-dom';
import Contributors from './contributors/ContributorsContainer';
import Contributions from './contributions/ContributionsContainer';
import AccountMaintenance from './accountmain';
import FormOrganization from './organizaton';
import EditableFunds from './Funds/EditFunds';
import ContributionsByMember from './contributions/ContributionsByMember'
import Reports from './reports';
import Test from './testpage';
import { user_roles } from './enums'
import Home from './Home'
import UserContainer from './Users/UsersContainer'
import AddUser from './Users/adduser'


export default class AppContent extends Component {

  fullMenuRoute() {
    return <div> 
      <Route exact path='/' render={(props) => <Home title='Home' {...props} />} />
      <Route exact path='/members' render={(props) => <Contributors title='Members details' {...props} />} />
      <Route path='/contribution' render={(props) => <Contributions title='Contribution details' {...props} />} />
      <Route path='/contributionByMember/:id' render={(props) => <ContributionsByMember title='Contribution details' {...props} />} />
      <Route path='/users' render={(props) => <UserContainer title='User management' {...props} />}  />
      <Route path='/organization' render={(props) => <FormOrganization title='Organisation details' {...props} />} />
      <Route path='/account' render={(props) => <AccountMaintenance title='Account Maintenance' {...props} />} />
      <Route path='/funds' render={(props) => <EditableFunds title='Pre-defined Funds' {...props} />} />
      <Route path='/reports/:report' render={(props) => <Reports {...props} />} />
      <Route path='/adduser' render={(props) => <AddUser title='Create New User' {...props} />} />
      <Route path='/test' render={(props) => <Test  {...props} />} />
    </div>
  }
  SummaryRoute() {
    return <div>
      <Route path='/reports/:report' render={(props) => <Reports {...props} />} />
    </div>
  }
  
  render() {
    return this.props.userRole === user_roles.SUMMARY_ONLY? this.SummaryRoute() : this.fullMenuRoute();
   }
}

